// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "paper-1ogu9";
var _3 = "additional-3vil5";
export { _1 as "__esModule", _2 as "paper", _3 as "additional" }
export default { "__esModule": _1, "paper": _2, "additional": _3 }
